// noinspection DuplicatedCode

import { container, singleton } from 'tsyringe';
import {
    authorizationHandler,
    AxiosHttp,
    Http,
    HttpStateCodeHandler,
    QueryStringObject,
    RequestFail,
    RequestInterceptor,
    ResponseInterceptor,
} from '@/Http';
import { BusinessResult } from '@/Domain';
import { 提示Service, 提示ServiceInjectToken } from '@/Services/提示Service';

@singleton()
export class NewMainClient {
    static SecuredClient(baseUrl: string, onUnauthorize?: () => void, onAuthenticationError?: () => void) {
        return new NewMainClient(
            baseUrl,
            [authorizationHandler],
            [HttpStateCodeHandler],
            onUnauthorize,
            onAuthenticationError
        );
    }
    static UnsecuredClient(baseUrl: string) {
        return new NewMainClient(baseUrl, [], [HttpStateCodeHandler]);
    }

    private readonly _baseUrl: string;
    private _onUnauthrized: (() => void) | undefined;
    private _onAuthenticationError: (() => void) | undefined;

    constructor(
        baseUrl: string,
        requestInterceptors: RequestInterceptor[],
        responseInterceptors: ResponseInterceptor[],
        onUnauthorize?: () => void,
        onAuthenticationError?: () => void
    ) {
        this._http = new AxiosHttp<BusinessResult<unknown>>({}, requestInterceptors, responseInterceptors);
        this._baseUrl = baseUrl;
        //TODO 对于Navigator更好的封装之后，应该可以替换下面这个callback
        this._onUnauthrized = onUnauthorize;
        this._onAuthenticationError = onAuthenticationError;
    }

    private _http: Http<BusinessResult<unknown>>;

    public get<T>(url: string, query?: QueryStringObject): Promise<T> {
        return new Promise((resolve, reject) => {
            const promise = this._http.get(this.getFullUrl(url), query) as Promise<BusinessResult<T>>;
            promise.then(this.BusinessErrorFilter(resolve, reject)).catch((requestFail: RequestFail) => {
                reject('错误:' + requestFail);
                if (requestFail === RequestFail.需要授权 && this._onUnauthrized) this._onUnauthrized();
                else if (requestFail === RequestFail.非法访问 && this._onAuthenticationError)
                    this._onAuthenticationError();
                else container.resolve<提示Service>(提示ServiceInjectToken).提示错误('错误:' + requestFail);
            });
        });
    }

    public post<T>(url: string, data?: unknown, query?: QueryStringObject): Promise<T> {
        return new Promise((resolve, reject) => {
            const promise = this._http.post(this.getFullUrl(url), data, query) as Promise<BusinessResult<T>>;
            promise.then(this.BusinessErrorFilter(resolve, reject)).catch((requestFail: RequestFail) => {
                reject('错误:' + requestFail);
                if (requestFail === RequestFail.需要授权 && this._onUnauthrized) this._onUnauthrized();
                else if (requestFail === RequestFail.非法访问 && this._onAuthenticationError)
                    this._onAuthenticationError();
                else container.resolve<提示Service>(提示ServiceInjectToken).提示错误('错误:' + requestFail);
            });
        });
    }

    private BusinessErrorFilter<T>(resolve: (value: PromiseLike<T> | T) => void, reject: (reason?: unknown) => void) {
        return (res: BusinessResult<T>) => {
            switch (res.state) {
                case 'Failed': {
                    const notifyService = container.resolve<提示Service>(提示ServiceInjectToken);
                    notifyService.提示错误(res.description);
                    reject(res.data);
                    break;
                }
                case 'Fatal': {
                    const notifyService = container.resolve<提示Service>(提示ServiceInjectToken);
                    notifyService.提示错误(`系统错误：${res.description}`);
                    reject(res.data);
                    break;
                }
                default:
                    resolve(res.data);
            }
        };
    }

    private getFullUrl(url: string) {
        return this._baseUrl + url;
    }
}
